module.exports = __webpack_public_path__ + "media/images/right-525ba9b9d7360d87c6cc32a8302203c3.png";